import React from 'react';

interface PlanFeature {
  text: string;
  available: boolean;
}

interface Plan {
  name: string;
  price: string;
  priceDetail: string;
  description: string;
  features: PlanFeature[];
  badge?: string;
  badgeColor?: string;
  highlighted?: boolean;
}

const plans: Plan[] = [
  {
    name: '無料プラン',
    price: '¥0',
    priceDetail: '月額・永久無料',
    description: 'まず試してみたい方へ。議事録作成は時間無制限。',
    features: [
      { text: '文字起こし・議事録作成（時間無制限）', available: true },
      { text: '基本議事録の生成', available: true },
      { text: '過去の議事録 最新2件まで閲覧', available: true },
      { text: 'オフライン議事録 無制限（ライト以上）', available: false },
      { text: 'オンラインAI機能（スタンダード）', available: false },
    ],
  },
  {
    name: 'ライトプラン',
    price: '¥480',
    priceDetail: '月額（年¥4,800）',
    description: 'オフライン議事録を制限なく使い倒したい方へ。',
    features: [
      { text: 'オフライン議事録作成 無制限', available: true },
      { text: '文字起こし 無制限（オフライン処理）', available: true },
      { text: '過去の議事録 全件閲覧', available: true },
      { text: 'オンラインAI機能（懸案抽出・Q&A等）', available: false },
      { text: '資料連携・議案書自動生成', available: false },
    ],
  },
  {
    name: 'スタンダードプラン',
    price: '¥980',
    priceDetail: '月額（年¥9,800）',
    description: 'オフライン無制限＋オンラインAI機能フル開放。',
    badge: 'おすすめ',
    badgeColor: '#2196F3',
    highlighted: true,
    features: [
      { text: 'オフライン議事録作成 無制限', available: true },
      { text: '過去の議事録 全件閲覧', available: true },
      { text: '懸案・アクション抽出 / Q&A機能', available: true },
      { text: '資料連携・議案書自動生成', available: true },
      { text: 'ダッシュボード（決定→アクション横断）', available: true },
    ],
  },
];

const PricingPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '40px 20px' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h1 style={{ textAlign: 'center', fontSize: '2rem', fontWeight: 'bold', marginBottom: '8px' }}>
          料金プラン
        </h1>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '40px' }}>
          月480円でオフライン議事録、月980円でAI機能フル。まず無料で試せる。
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '20px',
        }}>
          {plans.map((plan) => (
            <div
              key={plan.name}
              style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: plan.highlighted
                  ? '0 4px 20px rgba(33, 150, 243, 0.3)'
                  : '0 2px 8px rgba(0,0,0,0.1)',
                border: plan.highlighted ? '2px solid #2196F3' : '1px solid #e0e0e0',
                position: 'relative',
              }}
            >
              {plan.badge && (
                <span style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: plan.badgeColor || '#2196F3',
                  color: '#fff',
                  padding: '4px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                }}>
                  {plan.badge}
                </span>
              )}
              <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '8px' }}>
                {plan.name}
              </h2>
              <div style={{ marginBottom: '4px' }}>
                <span style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1a1a1a' }}>
                  {plan.price}
                </span>
                <span style={{ fontSize: '14px', color: '#666', marginLeft: '4px' }}>
                  {plan.priceDetail}
                </span>
              </div>
              <p style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>
                {plan.description}
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {plan.features.map((f, i) => (
                  <li key={i} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '8px',
                    fontSize: '14px',
                    color: f.available ? '#333' : '#bbb',
                  }}>
                    <span style={{ color: f.available ? '#4CAF50' : '#ddd', fontWeight: 'bold' }}>
                      {f.available ? '✓' : '✗'}
                    </span>
                    {f.text}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px', color: '#666', fontSize: '14px' }}>
          <p>全プラン、クレジットカード決済（Stripe）。いつでも解約可能。</p>
          <p>ご不明な点は <a href="mailto:workkantan@gmail.com">workkantan@gmail.com</a> までお問い合わせください。</p>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
